<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createPlanGroup') }}</h1>
      <div class="form-container">
        <PlanGroupForm @save="save"></PlanGroupForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import PlanGroupForm from '@/components/PlanGroupForm'

  export default {
    components: {
      DashboardLayout,
      PlanGroupForm
    },
    methods: {
      save(planGroup) {
        this.$store.dispatch('Docflow/createPlanGroup', {
          planGroup,
          documentId: this.$route.params.documentId
        }).then(() => {
          this.$router.go(-1)
        })
      }
    },
    computed: {
      breadcrumbs() {
        return [
          { name: 'docflow', path: 'docflow' },
          { name: 'createPlanGroup' }
        ]
      }
    }
  }
</script>
